import React, { useEffect, useState, useContext, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  BrowserRouter,
  Navigate,
  useParams,
} from "react-router-dom";
import { ROUTES } from "./constants/routes";

import { ErrorBoundary } from "react-error-boundary";
import Profile from "./Components/Profile";
import Referrals from "./Components/Referrals";
import ErrorFallback from "./Components/ErrorBoundary";
import Pricingui from "./Components/Pricingui";
import PaymentSuccessRedirect from "./Components/PaymentSuccessRedirect";
import Biling from "./Components/Biling";
import Mynotes from "./Components/Mynotes";
import CurrentAffairs from "./Components/CurrentAffairs";
import Interactivesyllabus from "./Components/InteractiveSyllabus";
import Sidebar from "./Components/Sidebar";
import Header from "./Components/Header";

import ChatWindow from "./Components/ChatWindow";
import Settings from "./Components/Profile";
import AdminPrompts from "./Components/AdminPrompts";
import "./App.css";
import "./landingscreen.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { getHistoryById, getMessageById } from "./services/getHistory";
import { parse } from "marked";
import AdminPromptsClean from "./Components/AdminPromptsClean";

// UPSC Admin Panel
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import AdminLayout from "./Components/Admin/AdminLayout";
import AdminProtectedRoute from "./Components/Admin/AdminProtectedRoute";
import { PERMISSIONS } from "./constants/adminPermissions";
import QuestionBankPage from "./Components/Admin/Modules/QuestionBank/QuestionBankPage";
import QuestionReportsPage from "./Components/Admin/Modules/QuestionReports/QuestionReportsPage";
import TestBuilderPage from "./Components/Admin/Modules/TestBuilder/TestBuilderPage";
import TestManagementPage from "./Components/Admin/Modules/TestManagement/TestManagementPage";
import UserManagementPage from "./Components/Admin/Modules/UserManagement/UserManagementPage";
import MentorManagementPage from "./Components/Admin/Modules/MentorManagement/MentorManagementPage";
import NotificationsPage from "./Components/Admin/Modules/Notifications/NotificationsPage";
import AnalyticsPage from "./Components/Admin/Modules/Analytics/AnalyticsPage";
import AdminUsersPage from "./Components/Admin/Modules/AdminManagement/AdminUsersPage";
import RolesPermissionsPage from "./Components/Admin/Modules/AdminManagement/RolesPermissionsPage";
import AuditLogsPage from "./Components/Admin/Modules/AuditLogs/AuditLogsPage";
import ForgetPassword from "./screens/forgetpassword";
import ResetPassword from "./screens/resetpassword";
import Signup from "./screens/signup";
import Login from "./screens/login";
import Homepage from "./screens/homepage";
// import Landingpage from "./landingpage";
import LoginEmail from "./screens/loginemail";
import PublicCADemo from "./edukemy-ca/PublicCADemo";
// import HangManApp from "./Hangman/src/App";
// import { ThemeContextProvider } from "./Hangman/src/state/theme-context";
import OtpValidation from "./screens/otpvalidation";
import { refreshTokens } from "./services/authenticationServices";
import ProtectedRoute from "./Components/ProtectedRoute";
import Onboarding from "./Components/OnbordingProcess";
import Register from "./screens/register";
// import { reactPlugin } from "./appInsights"; // Import Application Insights plugin
import { withAITracking } from "@microsoft/applicationinsights-react-js";
// import RouteTracker from "./RouteTracker"; // Import the tracking component
// import {  useKeycloak } from "@react-keycloak/web";
import { AuthProvider, AuthContext } from "./Hook/AuthProvider";
import { useInactivityDetector } from "./Hook/useInactivityDetector";
import { clearCacheOnPageLoad } from "./utils/cacheManager";

import McqPractice from "./Components/McqPractice";
import ReviewScreen from "./Components/Test/ReviewScreen";
import { Flag } from "lucide-react";
import CurrentAffairsLandingPage from "./Components/CurrentAffairsLandingpage";
import { Prev } from "react-bootstrap/esm/PageItem";
import StudyPlannernew from "./Components/StudyPlanner"
import { AdhocCA } from "./Components/AdhocCA";
import Settingsidebar from "./Components/SettingSidebar";
import Instructions from "./Components/Test/Instructions";
import TestScreen from "./Components/Test/TestScreen";
import TestSuccess from "./Components/Test/TestSuccess";
import Dashboard from "./Components/Dashboard";
import HistoryPage from "./Components/HistoryPage";
function RedirectCurrentAffairsArticle() {
  const { idd } = useParams();
  const location = useLocation();
  return <Navigate to={`${ROUTES.CURRENT_AFFAIRS}/${idd}${location.search}${location.hash}`} replace />;
}

function AppContent() {
  const [showPremiumButton, setShowPremiumButton] = useState(false);
  const [isSidebarColl, setIsSidebarColl] = useState(true);
  const [interactiveSyllabus, setInteractiveSyllabus] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const [headerTitle, setHeaderTitle] = useState("");
  const lowerPath = location.pathname.toLowerCase();
  const pageTitle = lowerPath === ROUTES.TESTS ? "My Tests"
    : lowerPath.includes(ROUTES.CURRENT_AFFAIRS) ? "Current Affairs"
    : lowerPath === ROUTES.SYLLABUS ? "Interactive Syllabus"
    : lowerPath === ROUTES.PLANNER ? "Study Planner"
    : lowerPath === ROUTES.NOTES ? "My Notes"
    : lowerPath.includes(ROUTES.CHAT) ? headerTitle
    : lowerPath === ROUTES.DASHBOARD ? "Dashboard"
    : lowerPath === ROUTES.HISTORY ? "History"
    : "";
  const [isStreamingDoneSidebar, setIsStreamingDoneSidebar] = useState(true);
  const [refreshHistory, setRefreshHistory] = useState(false);
  const [isHangmanDone, setIsHangmanDone] = useState(false);
  const [ismcq, setIsMcq] = useState(false);
  // const [loading, setLoading] = useState(true); // Show loader while checking token
  const sidebarclick = useRef(null);
  const lastClickOutside = useRef(false);
  const sidebarclickone = useRef(null);
  const [isClickOutsideSidebar, setIsClickOutsideSidebar] = useState(false);
  useEffect(() => {
    clearCacheOnPageLoad();
  }, []);
  useEffect(() => {
    const handleClick = (event) => {
      if (window.innerWidth <= 1023) {
        return;
      }

      if (sidebarclick.current && !sidebarclick.current.contains(event.target)) {
          setIsClickOutsideSidebar(true);
          setIsSidebarColl(true);
          lastClickOutside.current = true;
      } else {
        setIsClickOutsideSidebar(false);
        lastClickOutside.current = false;
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  // Normalize any /currentaffairs path variations (e.g. /CurrentAffairs/9963) to lowercase
  if (/^\/currentaffairslandingpage$/i.test(location.pathname)) {
    return <Navigate to={ROUTES.CURRENT_AFFAIRS + location.search + location.hash} replace />;
  }
  if (
    /^\/currentaffairs(\/.*)?$/i.test(location.pathname) &&
    !location.pathname.startsWith("/currentaffairs")
  ) {
    const normalizedPath = location.pathname.replace(/^\/currentaffairs/i, "/currentaffairs");
    return <Navigate to={normalizedPath + location.search + location.hash} replace />;
  }

  // Define the paths where the Sidebar and parent div should be hidden
  const noSidebarPaths = [
    "/",
    "/login",
    "/onbord",
    "/signup",
    "/register",
    "/forget-password",
    "/reset-password",
    "/hangman",
     ROUTES.LOGIN_EMAIL,
    "/otp-verification",
    "/test/instructions",
    "/test/active",
    "/test/success",
    "/test/review",
  ];

  const sideBarPaths = [
     ROUTES.DASHBOARD,
     ROUTES.CHAT,
     `${ROUTES.CHAT}/:conversationIdd`,
     `${ROUTES.CHAT}/message/:conversationIdd`,
     ROUTES.PLANNER,
     ROUTES.ADMIN_PROMPTS,
     ROUTES.TESTS,
     "/Price",
     `${ROUTES.HISTORY}/review`,
     ROUTES.CURRENT_AFFAIRS,
     `${ROUTES.CURRENT_AFFAIRS}/:idd`,
     "/CurrentAffairs",
     "/CurrentAffairs/:idd",
     ROUTES.NOTES,
     ROUTES.SYLLABUS,
     ROUTES.HISTORY,
    //  ROUTES.MISSIONS,
   ];

  function matchPathWithParams(pathPattern, pathname) {
    if (pathPattern.includes(":")) {
      // Convert "/cure/:id" to regex: ^/cure/[^/]+$
      const regex = new RegExp(
        "^" +
        pathPattern.replace(/:[^/]+/g, "[^/]+") +
        "$",
        "i"
      );
      return regex.test(pathname);
    }
    return pathPattern.toLowerCase() === pathname.toLowerCase();
  }

  const showSidebar = sideBarPaths.some((pattern) =>
    matchPathWithParams(pattern, location.pathname)
  );

  const isAdminPath = location.pathname.startsWith("/admin") && !location.pathname.startsWith("/adminprompts");

  // useEffect(() => {
  //   let isMounted = true;
  //   const checkAuthentication = async () => {
  //     const token = localStorage.getItem("access_token");
  //     if (token) {
  //       const isValid = await validateAccessToken(token);
  //       setIsAuthenticated(isValid);
  //       console.log("isValid", isValid,location.pathname)
  //       if (isValid) {
  //         if (showSidebar) {
  //           console.log("Here its gg")
  //           navigate(window.location.pathname);
  //         } else {
  //           console.log("Here its goin")
  //           navigate("/chatwindow");
  //         }
  //       } else {
  //         navigate(
  //           noSidebarPaths.includes(location.pathname)
  //             ? location.pathname
  //             : "/login"
  //         );
  //       }
  //     }

  //     // setLoading(false); // Stop loader once validation is complete
  //   };

  //   checkAuthentication();

  //   return () => {
  //     isMounted = false; // Cleanup function
  //   };
  // }, []);
  if ("speechSynthesis" in window) {
    window.speechSynthesis.cancel();
  }

  const parseMarkdown = (markdownText) => {
    return parse(markdownText);
  };

  const mapHistoryMessage = (item, messagesSource = []) => {
    const isAssistant = item.role === "assistant" || item.role === "bot";
    const source =
      isAssistant && item.id
        ? messagesSource.find((m) => m.id === item.id) || item
        : item;

    const keywordsRaw =
      source.keywords ??
      source.keywordsArray ??
      item.keywords ??
      item.keywordsArray ??
      null;

    return {
      sender: item.role === "user" ? "user" : "bot",
      message: item.message,
      template: item.template,
      messageId: item.id,
      theme: item.theme || source.theme || null,
      revise: isAssistant ? source.revise ?? item.revise ?? null : null,
      pyq: isAssistant ? source.pyq ?? item.pyq ?? null : null,
      keywords: keywordsRaw,
      keywordsArray: Array.isArray(keywordsRaw)
        ? keywordsRaw
        : Array.isArray(source.keywordsArray)
          ? source.keywordsArray
          : null,
      keywordsHtml: source.keywordsHtml ?? item.keywordsHtml ?? null,
      case_study:
        source.case_study ??
        source.caseStudies ??
        item.case_study ??
        item.caseStudies ??
        null,
      caseStudies:
        source.caseStudies ??
        source.case_study ??
        item.caseStudies ??
        item.case_study ??
        null,
      initiative:
        source.initiative ??
        source.initiatives ??
        item.initiative ??
        item.initiatives ??
        null,
      initiatives:
        source.initiatives ??
        source.initiative ??
        item.initiatives ??
        item.initiative ??
        null,
      current_affairs: source.current_affairs ?? item.current_affairs ?? null,
    };
  };

  const handleSelectHistoryItem = (conversation_id) => {

    getHistoryById(conversation_id)
      .then((response) => {

        const sortedResponse = response["messages"].sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        const context_response = {
          "id": "8b75626b-2324-4ef8-903b-fc3fe12fbb96",
          "message": response["context"] || "",
          "created_at": response["messages"][0]["created_at"],
          "role": "assistant",
          "template": "Generic",
          "context": null
        }


        const finalResponse = [context_response, ...sortedResponse];
        const transformedData = {
          id: conversation_id,
          title: response.messages[0].message, // Title is static for this example
          messages: finalResponse.map((item) =>
            mapHistoryMessage(item, response.messages)
          ),
        };
        setSelectedHistory(transformedData);
      })
      .catch((error) => console.error(error));
  };
  const handleSelectMessageItem = (conversation_id) => {

    getMessageById(conversation_id)
      .then((response) => {

        const sortedResponse = response["messages"].sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        const context_response = {
          "id": "8b75626b-2324-4ef8-903b-fc3fe12fbb96",
          "message": response["context"] || "",
          "created_at": response["messages"][0]["created_at"],
          "role": "assistant",
          "template": "Generic",
          "context": null
        }


        const finalResponse = [context_response, ...sortedResponse];
        const transformedData = {
          id: "",
          title: response.messages[0].message, // Title is static for this example
          messages: finalResponse.map((item) =>
            mapHistoryMessage(item, response.messages)
          ),
        };
        setSelectedHistory(transformedData);
      })
      .catch((error) => console.error(error));
  };



  function Check() {
    setIsSidebarColl(true);
  }

  const toggleSidebar = () => {
    setIsSidebarColl((prev) => !prev);
  };

  const wrapWithErrorBoundary = (Component, name) => (props) =>
  (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            backgroundColor: "#f8f9fa",
            border: "1px solid #dc3545",
            borderRadius: "8px",
            width: "50%",
            margin: "auto",
          }}
        >
          <h3 style={{ color: "#dc3545", marginBottom: "10px" }}>
            This section encountered an error
          </h3>
          <p style={{ color: "#666", marginBottom: "15px" }}>
            {error.message}
          </p>
          <button
            onClick={resetErrorBoundary}
            style={{
              padding: "8px 16px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      )}
      onReset={() => {
        // Reset the state of your app here
        window.location.reload();
      }}
      onError={(error, info) => {
        // Log the error
        console.error(`Error in ${name}:`, error);
        console.error("Component Stack:", info.componentStack);
      }}
    >
      <Component {...props} />
    </ErrorBoundary>
  );

  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f8f9fa",
          }}
        >
          <h2 style={{ color: "#dc3545", marginBottom: "20px" }}>
            Something went wrong with the application
          </h2>
          <p style={{ color: "#666", marginBottom: "15px" }}>{error.message}</p>
          <button
            onClick={resetErrorBoundary}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Reload Application
          </button>
        </div>
      )}
    >
      <AuthProvider>
        {isAdminPath ? (
          <AdminAuthProvider>
            <Routes>
              <Route
                path="/admin"
                element={
                  <AdminProtectedRoute requiredPermission={null}>
                    <AdminLayout />
                  </AdminProtectedRoute>
                }
              >
                <Route index element={<Navigate to={ROUTES.ADMIN_QUESTIONS_BANK} replace />} />
                <Route
                  path="tests/builder"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.TESTS_CREATE}>
                      <TestBuilderPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="tests/management"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.TESTS_READ}>
                      <TestManagementPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="questions/bank"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.QUESTIONS_READ}>
                      <QuestionBankPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="questions/reports"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.QUESTIONS_REVIEW}>
                      <QuestionReportsPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="users"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.USERS_READ}>
                      <UserManagementPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="mentors/assignment"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.MENTORS_READ}>
                      <MentorManagementPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="mentors/notifications"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.NOTIFICATIONS_CREATE}>
                      <NotificationsPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="mentors/reports"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.MENTORS_READ}>
                      <MentorManagementPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="analytics/users"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.ANALYTICS_READ}>
                      <AnalyticsPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="analytics/tests"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.ANALYTICS_READ}>
                      <AnalyticsPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="analytics/payments"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.ANALYTICS_READ}>
                      <AnalyticsPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="system/users"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.ADMIN_MANAGE}>
                      <AdminUsersPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="system/roles"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.ADMIN_MANAGE}>
                      <RolesPermissionsPage />
                    </AdminProtectedRoute>
                  }
                />
                <Route
                  path="system/audit-logs"
                  element={
                    <AdminProtectedRoute requiredPermission={PERMISSIONS.AUDIT_READ}>
                      <AuditLogsPage />
                    </AdminProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </AdminAuthProvider>
        ) : showSidebar ? (
          <div className="app-layout">
            <Header message={[{ message: pageTitle }]} Check={Check} isSidebarColl={isSidebarColl} flag={true} />
            <div className="app-body">
              <ErrorBoundary
                fallbackRender={({ error, resetErrorBoundary }) => (
                  <div
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #dc3545",
                      borderRadius: "8px",
                      margin: "20px",
                    }}
                  >
                    <h3 style={{ color: "#dc3545", marginBottom: "10px" }}>
                      Sidebar encountered an error
                    </h3>
                    <p style={{ color: "#666", marginBottom: "15px" }}>
                      {error.message}
                    </p>
                    <button
                      onClick={resetErrorBoundary}
                      style={{
                        padding: "8px 16px",
                        backgroundColor: "#007bff",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Try again
                    </button>
                  </div>
                )}
              >
                <Sidebar
                  setShowPremiumButton={setShowPremiumButton}
                  setIsClickOutsideSidebar={setIsClickOutsideSidebar}
                  isClickOutsideSidebar={isClickOutsideSidebar}
                  sidebarclick={sidebarclick}
                  sidebarclickone={sidebarclickone}
                  onSelectHistoryItem={handleSelectHistoryItem}
                  isSidebarColl={isSidebarColl}
                  setIsSidebarColl={setIsSidebarColl}
                  refreshHistory={refreshHistory}
                  setIsMcq={setIsMcq}
                  interactiveSyllabus={interactiveSyllabus}
                  setInteractiveSyllabus={setInteractiveSyllabus}
                  isStreamingDoneSidebar={isStreamingDoneSidebar}
                  setIsStreamingDoneSidebar={setIsStreamingDoneSidebar}
                  setRefreshHistory={() => {
                    setRefreshHistory(false);
                  }}
                />
              </ErrorBoundary>
              <div className="app-content">
                <Routes>
                <Route
                  path={ROUTES.DASHBOARD}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(Dashboard, "Dashboard")({})}
                    </ProtectedRoute>
                  }
                />
                <Route path="/Chatwindow" element={<Navigate to={ROUTES.CHAT} replace />} />
                <Route
                  path={`${ROUTES.CHAT}/:conversationIdd`}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        ChatWindow,
                        "ChatWindow"
                      )({
                        setShowPremiumButton,
                        showPremiumButton,
                        handleSelectHistoryItem,
                        selectedHistory,
                        Check,
                        isSidebarColl,
                        setIsSidebarColl,
                        ismcq,
                        interactiveSyllabus,
                        setInteractiveSyllabus,
                        setIsStreamingDoneSidebar,
                        setHeaderTitle,
                        setRefreshHistory: () => {
                          setRefreshHistory(true);
                        },
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route path="/Chatwindow/:conversationIdd" element={<Navigate to={ROUTES.CHAT} replace />} />
                <Route
                  path={ROUTES.CHAT}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        ChatWindow,
                        "ChatWindow"
                      )({
                        setShowPremiumButton,
                        showPremiumButton,
                        selectedHistory,
                        Check,
                        isSidebarColl,
                        setIsSidebarColl,
                        ismcq,
                        interactiveSyllabus,
                        setInteractiveSyllabus,
                        setIsStreamingDoneSidebar,
                        setHeaderTitle,
                        setRefreshHistory: () => {
                          setRefreshHistory(true);
                        },
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${ROUTES.CHAT}/message/:conversationIdd`}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        ChatWindow,
                        "ChatWindow"
                      )({
                        setShowPremiumButton,
                        showPremiumButton,
                        handleSelectMessageItem,
                        handleSelectHistoryItem,
                        selectedHistory,
                        Check,
                        isSidebarColl,
                        setIsSidebarColl,
                        setHeaderTitle,
                        ismcq,
                        interactiveSyllabus,
                        setInteractiveSyllabus,
                        setIsStreamingDoneSidebar,
                        setRefreshHistory: () => {
                          setRefreshHistory(true);
                        },
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.CURRENT_AFFAIRS}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}
 
                    >
                      {wrapWithErrorBoundary(
                        CurrentAffairsLandingPage,
                        "CurrentAffairsLandingPage"
                      )({
                        Check,
                        isSidebarColl,
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${ROUTES.CURRENT_AFFAIRS}/:idd`}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        CurrentAffairs,
                        "CurrentAffairs"
                      )({
                        Check,
                        isSidebarColl,
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route path="/CurrentAffairsLandingPage" element={<Navigate to={ROUTES.CURRENT_AFFAIRS} replace />} />
                <Route path="/CurrentAffairs" element={<Navigate to={ROUTES.CURRENT_AFFAIRS} replace />} />
                <Route
                  path="/CurrentAffairs/:idd"
                  element={<RedirectCurrentAffairsArticle />}
                />

                <Route
                  path={ROUTES.SYLLABUS}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        Interactivesyllabus,
                        "Interactivesyllabus"
                      )({
                        Check,
                        isSidebarColl,
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.NOTES}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        Mynotes,
                        "Mynotes"
                      )({
                        Check,
                        isSidebarColl,
                      })}
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path={ROUTES.MISSIONS}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        AdhocCA,
                        "AdhocCA"
                      )()}
                    </ProtectedRoute>
                  }
                /> */}
                <Route path="/Mynotes" element={<Navigate to={ROUTES.NOTES} replace />} />
                <Route path="/pricing" element={<Navigate to={ROUTES.BILLING} replace />} />
                <Route
                  path="/Price"
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}
                      isAuthenticated={isAuthenticated}
                    >
                      {wrapWithErrorBoundary(
                        Pricingui,
                        "Pricingui"
                      )({
                        Check,
                        isSidebarColl,
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.HISTORY}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        HistoryPage,
                        "HistoryPage"
                      )({
                        Check,
                        isSidebarColl,
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.TESTS}
                  element={
                    <ProtectedRoute isUnprotectedPage={false}>
                      {wrapWithErrorBoundary(
                        McqPractice,
                        "McqPractice"
                      )({ Check, isSidebarColl })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/review"
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        ReviewScreen,
                        "ReviewScreen"
                      )({})}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={ROUTES.PLANNER}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        StudyPlannernew,
                        "StudyPlannernew"
                      )({
                        Check,
                        isSidebarColl,
                      })}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.ADMIN_PROMPTS}
                  element={
                    <ProtectedRoute
                      isUnprotectedPage={false}

                    >
                      {wrapWithErrorBoundary(
                        AdminPromptsClean,
                        "AdminPromptsClean"
                      )({})}
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </div>
          </div>
        </div>
        ) : (
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute isUnprotectedPage={true}>
                  <Homepage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-success"
              element={
                wrapWithErrorBoundary(
                  PaymentSuccessRedirect,
                  "PaymentSuccessRedirect"
                )({})
              }
            />
            <Route
              path={ROUTES.LOGIN}
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  {wrapWithErrorBoundary(Login, "Login")({})}
                </ProtectedRoute>
              }
            />


            <Route
              path="/onboard"
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  {wrapWithErrorBoundary(Onboarding, "Onboarding")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.BILLING}
              element={
                <div style={{ display: "flex" }}>
                  <Settingsidebar />
                  <ProtectedRoute
                    isUnprotectedPage={false}
                    isAuthenticated={isAuthenticated}
                  >
                    {wrapWithErrorBoundary(Biling, "Biling")({})}
                  </ProtectedRoute>
                </div>
              }
            />

            <Route
              path={ROUTES.REFERRALS}
              element={
                <div style={{ display: "flex" }}>
                  <Settingsidebar />
                  <ProtectedRoute
                    isUnprotectedPage={false}
                    isAuthenticated={isAuthenticated}
                  >
                    {wrapWithErrorBoundary(Referrals, "Referrals")({})}
                  </ProtectedRoute>
                </div>
              }
            />

            <Route
              path={ROUTES.PROFILE}
              element={
                <div style={{ display: "flex" }}>
                  <Settingsidebar />
                  <ProtectedRoute
                    isUnprotectedPage={false}
                    isAuthenticated={isAuthenticated}
                  >
                    {wrapWithErrorBoundary(Profile, "Profile")({})}
                  </ProtectedRoute>
                </div>
              }
            />

                 <Route
              path="/edukemy-ca"
              element={
                
                <PublicCADemo/>
              }
            />
            <Route
              path={ROUTES.SIGNUP}
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  {wrapWithErrorBoundary(Signup, "Signup")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.LOGIN_EMAIL}
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  {wrapWithErrorBoundary(LoginEmail, "LoginEmail")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path="/forget-password"
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  {wrapWithErrorBoundary(ForgetPassword, "ForgetPassword")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path="/reset-password"
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  {wrapWithErrorBoundary(ResetPassword, "ResetPassword")({})}
                </ProtectedRoute>
              }
            />
       
            <Route
              path="*"
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  <Navigate to={ROUTES.DASHBOARD} replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hangman"
              element={
                <ProtectedRoute
                  isUnprotectedPage={false}
                  isAuthenticated={isAuthenticated}

                >
                  {/* <ThemeContextProvider>
                    {wrapWithErrorBoundary(HangManApp, "HangManApp")({})}
                  </ThemeContextProvider> */}
                </ProtectedRoute>
              }
            />
            <Route
              path="/otp-verification"
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}

                >
                  {wrapWithErrorBoundary(OtpValidation, "OtpValidation")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path="/logged-out"
              element={<Navigate to="/" replace />}
            />
            <Route
              path="/referral"
              element={
                <ProtectedRoute isUnprotectedPage={true}>
                  <></>
                </ProtectedRoute>
              }
            />
            <Route
              path="/test/instructions"
              element={
                <ProtectedRoute isUnprotectedPage={false} isAuthenticated={isAuthenticated}>
                  {wrapWithErrorBoundary(Instructions, "Instructions")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path="/test/active"
              element={
                <ProtectedRoute isUnprotectedPage={false} isAuthenticated={isAuthenticated}>
                  {wrapWithErrorBoundary(TestScreen, "TestScreen")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path="/test/success"
              element={
                <ProtectedRoute isUnprotectedPage={false} isAuthenticated={isAuthenticated}>
                  {wrapWithErrorBoundary(TestSuccess, "TestSuccess")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path="/test/review"
              element={
                <ProtectedRoute isUnprotectedPage={false} isAuthenticated={isAuthenticated}>
                  {wrapWithErrorBoundary(TestScreen, "TestScreen")({})}
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <ProtectedRoute
                  isUnprotectedPage={true}
                  isAuthenticated={isAuthenticated}
                >
                  <Navigate to={ROUTES.DASHBOARD} replace />
                </ProtectedRoute>
              }
            />
          </Routes>
        )}
      </AuthProvider>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f8f9fa",
          }}
        >
          <h2 style={{ color: "#dc3545", marginBottom: "20px" }}>
            Something went wrong with the application
          </h2>
          <p style={{ color: "#666", marginBottom: "15px" }}>{error.message}</p>
          <button
            onClick={resetErrorBoundary}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Reload Application
          </button>
        </div>
      )}
    >
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default function Root() {
  // Clear cache on fresh page load for clean start
 // Run only once on mount

  // If the user directly visits the Public CA demo path, render it immediately
  // without initializing AuthProvider / Keycloak or waiting for tokens.
  if (typeof window !== "undefined" && window.location.pathname === "/edukemy-ca") {
    return (
      <Router>
        <PublicCADemo />
      </Router>
    );
  }

  return (
    <Router>
      <App />
    </Router>
  );
}

// Wrap the root component with Application Insights tracking
// export default withAITracking(reactPlugin, App);
